<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>系统管理</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/user/userList' }">用户列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="box-body" style="min-height:80%;">
            <div class="search-div">
              <el-input v-model="name" placeholder="姓名" class="input-size-200 input-margin-right" clearable></el-input>
              <el-input v-model="phone" placeholder="手机" class="input-size-200 input-margin-right" clearable></el-input>
              <el-input v-model="departmentName" placeholder="学校" class="input-size-200 input-margin-right" clearable></el-input>
              <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索</el-button>
              <el-button type="success" icon="el-icon-plus" class="button-pull-right" style="margin-right: 20px" @click="handleCreate()">新增</el-button>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              :cell-style="{fontFamily: '宋体', fontSize: '16px'}"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange">
<!--              <el-table-column-->
<!--                type="selection"-->
<!--                fixed-->
<!--                width="50px">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                property="id"-->
<!--                label="ID"-->
<!--                fixed-->
<!--                width="100px">-->
<!--              </el-table-column>-->
              <el-table-column
                property="name"
                label="姓名"
                width="120px"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="phone"
                label="手机"
                width="120px"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="departmentName"
                label="学校名称"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <!--<el-table-column-->
                <!--property="bannedTime"-->
                <!--:formatter="dateFormat"-->
                <!--label="禁言时间"-->
                <!--width="150px"-->
                <!--sortable="custom"-->
                <!--show-overflow-tooltip>-->
              <!--</el-table-column>-->
<!--              <el-table-column-->
<!--              property="parentPhone"-->
<!--              label="父账户手机"-->
<!--              width="100px"-->
<!--              sortable="custom"-->
<!--              show-overflow-tooltip>-->
<!--              </el-table-column>-->
              <el-table-column
                prop="type"
                label="标签"
                width="120"
                class-name="money"
              >
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.type === 'ORDINARY' ? 'primary' : 'success'"
                    close-transition>{{scope.row.type=='ORDINARY'?'平台管理员':'学校管理员'}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                property="updatedUserName"
                label="录入人"
                width="100px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="createdAt"
                label="创建时间"
                width="110px"
                :formatter="dateFormat"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="updatedAt"
                label="修改时间"
                width="110px"
                :formatter="dateFormat"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="330px" class-name="money">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.phone != '83878320331'"
                    size="small"
                    @click="handleEdit(scope.$index, scope.row)">编辑
                  </el-button>
                  <el-button
                    size="small"
                    type="warning"
                    @click="handleAuth(scope.$index, scope.row)">权限
                  </el-button>
                  <el-button
                    v-if="scope.row.phone != '83878320331'"
                    size="small"
                    type="info"
                    @click="handleResetPassword(scope.$index, scope.row)">重置密码
                  </el-button>
                  <el-button
                    v-if="scope.row.phone != '83878320331' && scope.row.status != 'DISABLED'"
                    size="small"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>
        <el-dialog title="禁言时间" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <div class="block" style="text-align: center">
              <span>选择时间</span>
              <el-date-picker
                v-model="banDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleBan()">确 定</el-button>
          </div>
        </el-dialog>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: 'UserList',
    data: function () {
      let that = this;
      return {
        //  表格设置
        extnedsParms: {},
        dt: DataTable.getInstance(that, '/admin/user/findPageAdmin', null, null),
        name: '',
        phone: '',
        departmentName: '',
        banDate: '',
        dialogFormVisible: false,
        banId: ''
      }
    },

    mounted: function () {
      // 清理旧的绑定属性
      this.dt.cleanBindFields();
      // 绑定过滤属性
      this.dt.bindStringField("name", "name");
      this.dt.bindStringField("phone", "phone", "user.phone");
      this.dt.bindStringField("departmentName", "departmentName");
      // 还原之前查询条件到Vue属性
      this.dt.bindFieldToVueProp();
      //  向后台查询数据
      this.dt.queryPageData()
    },

    methods: {
      dateFormat: function (row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "";
        }
        return this.$moment(date).format("YYYY-MM-DD");
      },
      //  创建新记录
      handleCreate: function () {
        this.$router.push('/user/userModify')
      },
      // 编辑记录
      handleEdit: function (index, row) {
        // console.debug(index + ' ' + row.id)
        this.$router.push({path: '/user/userModify', query: {id: row.id}})
      },
      // 权限
      handleAuth: function (index, row) {
        this.$router.push({path: '/staff/authModify', query: {id: row.id, userType: row.type}})
      },
      // 搜索
      search: function () {
        // 更新最新的查询条件
        this.dt.bindFieldToFilter();
        this.dt.queryPageData()
      },
      // 重置密码
      handleResetPassword: function (index, row) {
        this.$confirm('此操作将重置该用户密码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                this.axios.post('/admin/user/resetPassword', [], {params: {id: row.id}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done()
                      this.dt.queryPageData()
                      this.$message({
                        type: 'success',
                        message: '处理成功'
                      })
                    } else {
                      done()
                      this.$message({
                        type: 'error',
                        message: '处理失敗'
                      })
                    }
                  }).catch(resp => {
                  done()
                  this.$message({
                    type: 'error',
                    message: '处理失敗'
                  })
                })
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      },
      // 删除
      handleDelete: function (index, row) {
        this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                this.axios.post('/admin/user/deleteUser', [], {params: {id: row.id}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done()
                      this.dt.queryPageData()
                      this.$message({
                        type: 'success',
                        message: '刪除成功'
                      })
                    } else {
                      done()
                      this.$message({
                        type: 'error',
                        message: '刪除失敗'
                      })
                    }
                  }).catch(resp => {
                  done()
                  this.$message({
                    type: 'error',
                    message: '刪除失敗'
                  })
                })
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      transformUser: function (index, row) {
        this.$confirm('请确认是否把该用户转换成员工, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                this.axios.post('/admin/user/transformUser', [], {params: {userId: row.id, type: "staff"}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done()
                      this.dt.queryPageData()
                      this.$message({
                        type: 'success',
                        message: '转换成功'
                      })
                    } else {
                      done()
                      this.$message({
                        type: 'error',
                        message: '转换失敗'
                      })
                    }
                  }).catch(resp => {
                  done()
                  this.$message({
                    type: 'error',
                    message: '转换失敗'
                  })
                })
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消转换'
          })
        })
      }
    }
  }
</script>
<style type="scss">
.money {
  font-family: '宋体';
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// UserList.vue?42a623db